import { orZero } from 'lib/utils/NumUtils';
import { sortFunctions } from './config';

export const sortLandingPages = (pages, performanceOption, metricOption, user) => {
    if (!pages || !pages.length) return pages;
    let result;
    let sortOption = performanceOption + ' ' + metricOption;
    let goals = user?.metadata?.goals;
    if (goals) goals.roasGoal = parseFloat(orZero(goals.aovGoal / goals.cppGoal)); // todo: move this to a user.getGoals() utility.

    if ((performanceOption == 'Above Goal' || performanceOption == 'Below Goal') && goals) {
        // filter first:
        result = pages.filter(c => {
            if (metricOption == 'ROAS') {
                return performanceOption == 'Above Goal' ? c.totals.roas >= goals.roasGoal : c.totals.roas < goals.roasGoal;
            } else if (metricOption == 'AOV') {
                return performanceOption == 'Above Goal' ? c.totals.aov >= goals.aovGoal : c.totals.aov < goals.aovGoal;
            } else if (metricOption == 'CPP') {
                return performanceOption == 'Above Goal' ?
                    (c.totals.cpp >= goals.cppGoal) :
                    (c.totals.items == 0 ? false : c.totals.cpp < goals.cppGoal);
            }
            return false;
        });

        // change sort options for these performance options:
        if (metricOption == 'ROAS') {
            sortOption = performanceOption == 'Above Goal' ? 'Highest ROAS' : 'Highest ROAS';
        } else if (metricOption == 'AOV') {
            sortOption = performanceOption == 'Above Goal' ? 'Highest AOV' : 'Highest AOV';
        } else if (metricOption == 'CPP') {
            sortOption = performanceOption == 'Above Goal' ? 'Highest CPP' : 'Highest CPP';
        }
    } else {
        // dont filter anything
        result = pages;
    }

    // sort them all
    let sortFn = sortFunctions[sortOption];
    if (sortFn) {
        result.sort(sortFn);
    }

    return result;
}